module.exports = __webpack_public_path__ + "static/media/higuchi-building-1.beb84373.jpg";